"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsync2 = void 0;
var AsyncUtils_1 = require("./AsyncUtils");
var react_1 = require("react");
function useAsync2(fx, search, searchDeps) {
    var _this = this;
    var _a = (0, react_1.useState)(true), loading = _a[0], setLoading = _a[1];
    var _b = (0, react_1.useState)(null), value = _b[0], setValue = _b[1];
    var _c = (0, react_1.useState)(null), error = _c[0], setError = _c[1];
    var _d = (0, react_1.useState)(0), _ = _d[0], setLoadId = _d[1];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var cb = (0, react_1.useMemo)(function () { return fx; }, []);
    var memoizedSearch = (0, react_1.useMemo)(function () { return search; }, searchDeps || [search]);
    var reload = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var thisLoadId_1, result, isActiveRequest_1, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setError(null);
                    setLoading(true);
                    thisLoadId_1 = 0;
                    setLoadId(function (old) {
                        thisLoadId_1 = (old + 1) % 1000;
                        return thisLoadId_1;
                    });
                    return [4 /*yield*/, (0, AsyncUtils_1.addDevelopmentDelay)(cb(memoizedSearch))];
                case 1:
                    result = _a.sent();
                    isActiveRequest_1 = true;
                    setLoadId(function (old) {
                        isActiveRequest_1 = old === thisLoadId_1;
                        return old;
                    });
                    if (!isActiveRequest_1)
                        return [2 /*return*/];
                    if (result && typeof result === 'object' && 'error' in result)
                        throw new Error(result.error);
                    setValue(result);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    setError(e_1.toString());
                    return [3 /*break*/, 3];
                case 3:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [cb, memoizedSearch]);
    (0, react_1.useEffect)(function () {
        reload();
    }, [reload]);
    var LoadingElement = (0, AsyncUtils_1.LoadingEl)(loading, error, reload);
    var NoResultElement = (0, AsyncUtils_1.NoResultEl)(LoadingElement, value);
    return {
        LoadingElement: LoadingElement,
        NoResultElement: NoResultElement,
        LoadingOrErrorElement: LoadingElement,
        loadingOrError: loading || error !== null,
        loading: loading,
        error: error,
        result: value,
        asList: value || defaultArray,
        reload: reload,
    };
}
exports.useAsync2 = useAsync2;
var defaultArray = [];
